import { useState, useEffect } from 'react';
import Page from '../components/Page';
import cafeMenu from '../static/pdf/Cafe_Menu.pdf';
import plattegrond from '../static/pdf/DS_-_PLATTEGROND_2_798.pdf';
import image from '../static/images/Cafe.webp';

const Cafe = (props) => {

  const [innerContent, setInnerContent] = useState('');
  const [innerContentEN, setInnerContentEN] = useState('');

  document.title = 'Café DS - De School Amsterdam';
  const headerTitle = props.langNL ? 'Café DS' : 'Cafe DS' ;


  useEffect(() => {
    fetch('./content/cafe-NL.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContent(html);
  });

    fetch('./content/cafe-EN.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContentEN(html);
  });
    },[]);

  const description = 'Café Café Café Café Café Café Café Café Café Café Café Café ';
  const descriptionEN = 'Cafe Cafe Cafe Cafe Cafe Cafe Cafe Cafe Cafe Cafe Cafe Cafe ';

  const content = <div className="content"
    dangerouslySetInnerHTML={{__html: innerContent ? innerContent : ''}}></div>

  const contentEN = <div className="content"
  dangerouslySetInnerHTML={{__html: innerContentEN ? innerContentEN : ''}}></div>


  return <Page
          headerTitle={headerTitle}
          // routeTitle={routeTitle}
          // routeLink={routeLink}
          // extraTitleOne={extraTitleOne}
          // extraTitleOneLink={extraTitleOneLink}
          description={props.langNL ? description : descriptionEN}
          content={props.langNL ? content : contentEN}
          langNL={props.langNL}
          changeLang={props.changeLang}
          image={image}
          />
};

export default Cafe;
